export function showInMapClicked(latitude: string, longitude: string): void {
    window.open("https://maps.google.com?q="+latitude+","+longitude );
};